<template>
  <div id="micio_miao" class="micio_miao">
    <!--:disabled="boxes.length > 5"-->
    <v-btn fab fixed right color="secondary" @click="signalForDialog(); eventSave = true; productSave = true " class="mt-3">
      <v-icon>add</v-icon>
    </v-btn>
    <v-container v-if="activeGrid" grid-list-md text-xs-center fill-height>
      <v-layout row wrap>
        <v-flex v-for="el in boxes.slice(0,3)" :key="el.componentId" xs4>
          <v-card color="primary">
            <keep-alive>
              <component :is="el.component" v-bind:properties="el"/>
            </keep-alive>
          </v-card>
        </v-flex>
        <v-flex v-for="el in boxes.slice(3)" :key="el.componentId" xs4>
          <v-card color="primary">
            <keep-alive>
              <component :is="el.component" v-bind:properties="el"/>
            </keep-alive>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else>
      <!-- <keep-alive> -->
      <component :is="bigComponet" v-bind:properties="bigComponetProperties"/>
      <!-- </keep-alive> -->
    </v-container>

    <v-dialog persistent v-model="dialog" width="900px" hide-overlay>
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          {{$translate('NEW_QUADRANT')}}
        </v-card-title>
        <v-container grid-list-md text-xs-left>
          <v-layout row wrap>
            <v-flex xs7>
              <v-select
                prepend-icon="view_headline"
                v-model="newQuad.type"
                :items="typeQuadrant"
                :label="$translate('TYPE_QUADRANT')"
                @change="quadrantTypeSelected()"
              ></v-select>
              <v-autocomplete
                v-if="isCalendar"
                v-model="newQuad.object"
                :items="eventsForQuadrant"
                :loading="isLoading"
                :search-input.sync="searchString"
                hide-no-data
                hide-selected
                item-text="Name"
                item-value="EventId"
                :label="$translate('SEARCH')"
                prepend-icon="view_headline"
                :placeholder="$translate('START_TYPING')"
                :disabled="makeChoiceEvents"
                return-object
                @change="eventSelected(); eventSave = false"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                v-model="newQuad.object"
                :items="locationsForQuadrant"
                :loading="isLoading"
                :search-input.sync="searchString"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="locationId"
                :label="$translate('SEARCH')"
                clearable
                prepend-icon="view_headline"
                :placeholder="$translate('START_TYPING')"
                :disabled="makeChoiceEvents"
                @change="eventSave = false"
                return-object
              ></v-autocomplete>
              <v-select
                v-if="eventIsSelected && newQuad.type === 'ProductCalendar'"
                prepend-icon="view_headline"
                v-model="selectedProduct"
                return-object
                :items="products"
                item-text="Name"
                item-value="Id"
                attach
                :menu-props="{ maxHeight: 150 }"
                label="Products"
                @change="productSave = false"
                :disabled="productToggle"
              ></v-select>
              <v-select
                v-else
                prepend-icon="view_headline"
                v-model="userGroupSelections"
                :items="userGroups"
                attach
                :menu-props="{ maxHeight: 150 }"
                label="Usergroups"
                multiple
                :disabled="userGroupsDisabled"
              ></v-select>
              <v-select
                v-if="newQuad.hasOwnProperty('object')
                && newQuad.object.Type === 'OrderEvent'
                && newQuad.type === 'EventCalendar'"
                prepend-icon="view_headline"
                v-model="newQuad.object.OrderType"
                :items="['Delivery', 'TakeAway']"
                :label="$translate('SELECT_ORDERTYPE')"
              ></v-select>
              <v-select
                v-if="newQuad.hasOwnProperty('object')
                && newQuad.object.Type === 'OrderEvent'
                && newQuad.type === 'EventCalendar'"
                prepend-icon="view_headline"
                v-model="newQuad.object.ChosenLocation"
                :items="allLocationsOnEvent"
                :label="$translate('SELECT_LOCATION')"
                item-text="LocationName"
                item-value="LocationId"
              ></v-select>
              <v-checkbox
                label="Default"
                v-model="newQuad.isDefault"
              ></v-checkbox>
            </v-flex>
            <v-flex xs5 class="pa-2">
              <h3>{{$translate('QUADRANT_DESC')}}</h3>
              <p>{{setCorrectDescription(newQuad.type)}}</p>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round color="secondary" @click="dialog = false; makeChoiceEvents = true">{{$translate('CANCEL')}}</v-btn>
          <v-btn v-if="newQuad.type !== 'ProductCalendar'" :disabled="eventSave" round color="primary" @click="addQuadrant()">{{$translate('SAVE')}}</v-btn>
          <v-btn v-else :disabled="productSave" round color="primary" @click="addQuadrant()">{{$translate('SAVE')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import QuadrantObject, { makeBox } from "../../objects/QuadrantObject";
import OperationalScreen_MapQuadrant from "./OperationalScreen_MapQuadrant";
import OperationalScreen_BaseQuadrant from "./OperationalScreen_BaseQuadrant";
import OperationalScreen_EventQuadrant from "./OperationalScreen_EventQuadrant";
import OperationalScreen_IncidentQuadrant from "./OperationalScreen_IncidentQuadrant";
import OperationalScreen_ProductCalendar from "./OperationalScreen_ProductCalendar";
import OperationalScreen_EventCalendar from "./OperationalScreen_EventCalendar";
import OperationalScreen_WebshopOverview from "./OperationalScreen_WebshopOverview";
import BaseObject from "../../objects/BaseObject";
import locationsModule from "@/store/modules/locations";
import LocationObject from "../../objects/LocationObject";
import { mapGetters } from "vuex";
import * as dssRequest from "../../api/dssRequest";
import appConfig from "../../../config/app_config";
import _ from "lodash";

export default {
  name: "OperationalScreen_Main",

  computed: {
    ...mapGetters({
      operationalScreenParam: "getOperationalScreenSize",
      currentAccountId: "getCurrentAccountId"
    }),
  },
  components: {
    OperationalScreen_MapQuadrant,
    OperationalScreen_IncidentQuadrant,
    OperationalScreen_EventQuadrant,
    OperationalScreen_BaseQuadrant,
    OperationalScreen_ProductCalendar,
    OperationalScreen_EventCalendar,
    OperationalScreen_WebshopOverview
  },
  data() {
    return {
      eventDetails: {},
      productSave: true,
      eventSave: true,
      allLocationsOnEvent: [],
      selectedEvent: {},
      locationsForQuadrant: [],
      eventsForQuadrant: [],
      bigComponet: {},
      bigComponetProperties: {},
      activeGrid: true,
      searchString: "",
      isLoading: false,
      typeQuadrant: [
        "Map",
        "Event",
        "Incident",
        "ProductCalendar",
        "EventCalendar",
        "WebshopOverview"
      ],
      notifications: false,
      userGroups: ["Members", "Staff", "VIP", "Participants"],
      userGroupSelections: [],
      userGroupsDisabled: true,
      makeChoiceEvents: true,
      isCalendar: false,
      eventIsSelected: false,
      productToggle: true,
      products: [],
      selectedProduct: {},
      dialog: false,
      newQuad: {},
      dragStatus: 0,
      columns: 3,
      rows: 1,
      layoutJson: [],
      settings: {
        columns: 3,
        rows: 2,
        margin: 5,
        bubbleUp: false,
        cellSize: {
          w: 50,
          h: 50
        }
      },
      baseProfile: {
        tag: "",
        default: false,
        style: {
          height: ""
        },
        floatingWindows: true
      },
      windowWidth: 100,
      windowHeight: 100,
      boxes: [],
      componentId: 0,
      oneGridFullScreen: false,

      // Qudrant types
      QUDRANT_TYPE_WEBSHOP_OVERVIEW: 'WebshopOverview'
    };
  },

  // watch: {
  //   getQuadrantWidth() {
  //     console.log("getQuadrantWidth", this.windowWidth);
  //     return this.windowWidth / this.columns;
  //   },
  //   getQuadrantHeight() {
  //     console.log("getQuadrantHeight", this.windowHeight);
  //     return this.windowHeight / this.rows;
  //   }
  // },
  created() {
    this.$store.commit("setUserIsInQuadrantScreen", false);
  },
  beforeDestroy() {
    let page = "OperationalScreen_Main";
    this.$store.commit("setShowButton", true);
    this.$store.commit("setUserIsInQuadrantScreen", true);
    this.$store.commit("setCurrentComponent", page);
    window.EventBus.removeListener("removeQuadrant", this.removeQuadrant);
    window.EventBus.removeListener(
      "toggleSizeQuadrant",
      this.toggleSizeQuadrant
    );
    this.$store.commit('setSeeMapInOprMapQua', false);
  },
  mounted() {
    this.$store.commit("setShowButton", false);
    this.$store.commit('setSeeMapInOprMapQua', true);
    this.getLocationsForQuadrant();
    window.EventBus.listen("removeQuadrant", this.removeQuadrant);
    window.EventBus.listen("toggleSizeQuadrant", this.toggleSizeQuadrant);

    // let page = "OperationalScreen_Main";
    // this.$store.commit("setCurrentComponent", page);

    //default map element
    // this.mapProperty = makeBox(
    //   {
    //     type: "MapElement",
    //     profile: this.baseProfile,
    //     signalMap: new Map(),
    //     tag: "",
    //     _x: 0,
    //     _y: 0,
    //     paramFlag: true,
    //     componentId: this.componentId,
    //     columns: this.columns,
    //     rows: this.rows
    //   },
    //   this.windowHeight,
    //   this.windowWidth
    // );

    this.$nextTick(() => {
      window.addEventListener("resize", this.getWindowSize);

      // //Init
      this.getWindowSize();
    });
    // default map element
    // this.boxes.push(this.mapProperty);
    this.loadConfiguration();
    this.loadUserGroups();
  },
  methods: {
    setCorrectDescription(type) {
      switch (type) {
        case 'Map':
          return this.$translate('MAP_QUADRANT_DESC');
        case 'Event':
          return this.$translate('EVENT_QUADRANT_DESC');
        case 'Incident':
          return this.$translate('INCIDENT_QUADRANT_DESC');
        case 'ProductCalendar':
          return this.$translate('PRODUCTCAL_QUADRANT_DESC');
        case 'EventCalendar':
          return this.$translate('EVENTCAL_QUADRANT_DESC');
        default:
          return this.$translate('BASIC_QUADRANT_DESC');
      }
    },
    getLocationsForQuadrant(event = {}) {
      const payload = {
        PartnerId: this.$store.getters['auth/partnerId'],
        FunctionId: "LocationFunctionLibrary::getLocationsV2"
      };
      if (!_.isEmpty(event)) {
        delete payload.FunctionId;
      }
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call 'getLocationsV2' on - OperationalScreen_Main.vue - was successful",
            response
          );
          if (!_.isEmpty(event)) {
            this.allLocationsOnEvent = response.data.Locations;
            this.newQuad.object.ChosenLocation = this.allLocationsOnEvent[0];
          }
          if (!response.data.hasOwnProperty('Locations')) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
            return;
          }
          if (response.data.Locations !== undefined) {
            console.log("locationsForQuadrant", this.locationsForQuadrant)
            this.locationsForQuadrant = LocationObject._createArrayWithObjects(
              response.data.Locations
            );
            window.EventBus.fire("functionStatus", {
              f: "getAllLocations",
              status: "ok",
              error: false
            });
            console.log("locationsForQuadrant", this.locationsForQuadrant)
          }
        },
        error => {
          console.log(
            "The generic call 'getLocationsV2' on - OperationalScreen_Mail.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');

        },
        _.isEmpty(event) ? "communicateWithDBLibrary" : 'getLocations',
        _.isEmpty(event) ? appConfig.dss.locationMgr : event.EventId,
        payload,
        600000,
        false
      );
    },
    getEvents() {
      // Method to get all the themes for current account
      let userLanguage = 0;
      if (this.$store.getters.getUserLanguage !== '') {
        userLanguage = this.$store.getters.getUserLanguage;
      }
      const payload = {
        LanguageTagId: Number(userLanguage),
      };
      if (this.$store.getters['auth/partnerId'] !== -1) {
        payload.PartnerId = this.$store.getters['auth/partnerId'];
      }
      if (this.newQuad.type === 'EventCalendar') {
        payload.EventTypes = [
          'Rental',
          'Repetetive',
          'Tour',
          'FlexEvent',
          'Fixed',
        ];
      } else if (this.newQuad.type === this.QUDRANT_TYPE_WEBSHOP_OVERVIEW) {
        payload.EventTypes = [
          'Webshop'
        ];
      } else {
        payload.EventTypes = [
          'Rental',
        ];
      }

      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getEvents was successful', response);
          let x = Object.values(response.data.Events);
          this.eventsForQuadrant = [];
          x.forEach((item) => {
            this.eventsForQuadrant.push(item);
          });
        },
        (error) => {
          console.log('The generic call getEvents was not successful', error);
        },
        'getEvents',
        'LocationsNode_ESE',
        payload,
      );
    },
    getProducts(id) {
      console.log("Laurens id", id);

      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getProducts was successful', response);

          let products = Object.values(response.data.Products);

          products.forEach((product) => {
            this.products.push(product);
          });
        },
        (error) => {
          console.log(
            'The generic call getProducts was not successful',
            error,
          );
        },
        'getProductsV2',
        id.EventId,
        payload,
      );
    },
    loadUserGroups() {
      this.userGroups = [];
      let currentUserId = this.$store.getters["auth/userName"];
      let payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        Columns: {
          TagGroup: "UserGroup",
          AccountId: this.$store.getters.getCurrentAccountId
        },
        TableName: "config.TagDef",
        ReplyName: "TagDef",
        Fields: {
          Description: "Description"
        }
      };
      dssRequest.doRequest(
        response => {
          let ugArray = response.data.TagDef.celldata;
          if (ugArray) {
            if (ugArray.length > 0) {
              for (const element of ugArray) {
                if (element[0] !== "UserGroup") {
                  this.userGroups.push(element[0]);
                }
              }
            } else {
            }
          } else {
          }
        },
        error => {},
        "communicateWithDBLibrary",
        appConfig.dss.accountManagerObjectId,
        payload
      );
    },
    quadrantTypeSelected() {
      this.productToggle = true;
      this.eventIsSelected = false;
      this.makeChoiceEvents = false;
      this.isCalendar = false;
      if (this.newQuad.type == "Map") {
        this.userGroupsDisabled = false;
      } else if (this.newQuad.type === "ProductCalendar" ||
                 this.newQuad.type === 'EventCalendar' ||
                 this.newQuad.type === this.QUDRANT_TYPE_WEBSHOP_OVERVIEW) {
        this.getEvents();
        this.isCalendar = true;
      } else {
        this.userGroupsDisabled = true;
      }
    },
    eventSelected() {
      this.eventIsSelected = true;
      if (this.newQuad.type === 'EventCalendar') {
        console.log("Lorenzo this.newQuad.object", this.newQuad.object);
        this.getLocationsForQuadrant(this.newQuad.object);
        return;
      } else if(this.newQuad.type === this.QUDRANT_TYPE_WEBSHOP_OVERVIEW) {
        // Event selected for WebshopOverview
        this.getLocationsForQuadrant(this.newQuad.object);
        return;
      }
      this.products = [];
      this.getProducts(this.newQuad.object);
      this.productToggle = false;
    },
    signalForDialog() {
      this.selectedProduct = {};
      this.selectedEvent = {};
      this.products = [];
      this.newQuad = {};
      this.dialog = true;
    },
    toggleSizeQuadrant(data) {
      const o = this.boxes.filter(e => e.componentId == data);
      console.log(
        this.$options.name,
        "toggleSizeQuadrant",
        data,
        this.boxes,
        o
      );
      if (o.length != 0) {
        this.bigComponet = o[0].component;
        this.bigComponetProperties = o[0];
      }
      this.activeGrid = !this.activeGrid;
      if (this.activeGrid) {
        this.$store.commit("setEnlargedQuadrant", false);
      } else {
        this.$store.commit("setEnlargedQuadrant", true);
      }
      console.log(
        this.$options.name,
        "toggleSizeQuadrant",
        this.activeGrid,
        this.bigComponet,
        this.bigComponetProperties
      );
    },
    updateCurrentAccountId(newVal, oldVal) {
      console.log(
        this.$options.name,
        "updateCurrentAccountId watch",
        newVal,
        oldVal
      );
    },
    loadConfiguration() {
      // This used to be the generic call getUserQuadrants
      let payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        TableName: "config.UserQuadrants",
        ReplyName: "UserQuadrants",
        Columns: {
          UserId: this.$store.getters["auth/userName"]
        }
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getUserQuadrants was successful",
            response
          );
          console.log("user quadrants data", response.data.UserQuadrants);
          let prefs = BaseObject._createArrayWithObjects(
            response.data.UserQuadrants
          );
          console.log("Lorenzo prefs", prefs);
          for (const key in prefs) {
            if (prefs.hasOwnProperty(key)) {
              const obj = JSON.parse(prefs[key].Quadrants);
              console.log("Lorenzo obj", obj);
              for (const [k1, v1] of Object.entries(obj)) {
                console.log("Laurens v1, k1", v1, k1);

                if (k1 == "columns") {
                  this.columns = v1;
                } else if (k1 == "rows") {
                  this.rows = v1;
                } else {
                  let q = v1;
                  q.signalObjectMap = new Map(q.signalObjectMap);
                  //escamotage to do not add map or other element in position 0 0
                  if (
                    !(q.position.x == -1 && q.position.y == -1) &&
                    (q.position.x !== null && q.position.y !== null) &&
                    q.name != "OperationalScreen_MapQuadrant_0"
                  ) {
                    this.boxes.push(q);
                    // Get the chosen location id
                    let objId = q.signalObjectMap.entries().next().value[0];
                    console.log("Laurens objId", objId);

                    this.$store.commit("setChosenLocationId", objId);
                  }
                  this.componentId++;
                }
              }
            }
          }
        },
        error => {
          console.log(
            "The generic call getUserQuadrants was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.accountManagerObjectId,
        payload
      );
    },
    reloadQuadrant() {
      this.boxes = [];
      this.boxes.push(
        makeBox(
          {
            type: "OperationalScreen_MapQuadrant",
            profile: this.map1Profile,
            signalMap: this.sigObjMap2,
            tag: "",
            _x: 0,
            _y: 0,
            paramFlag: false,
            componentId: this.componentId,
            columns: this.columns,
            rows: this.rows,
          },
          this.windowHeight,
          this.windowWidth
        )
      );
      this.loadConfiguration();
    },
    removeBox(id) {
      let index = this.boxes.findIndex(i => i.componentId === id);
      if (index !== -1) {
        this.boxes.splice(index, 1);
      }
    },
    getCurrentPropertyTable() {
      let params = {
        columns: this.columns,
        rows: this.rows
      };
      console.log("Lorenzo params", params);
      for (let i = 0; i < this.boxes.length; i++) {
        if (this.boxes[i].profile.default == false) {
          //TODO
        }
      }

      for (let i = 0; i < this.boxes.length; i++) {
        // these two if statements are there to take out the imageToBase64 strings before we send to the back-end
        if(this.boxes[i].hasOwnProperty("product")) {
          if (this.boxes[i].product.Picture !== '') {
            this.boxes[i].product.Picture = '';
          }
          if(this.boxes[i].product.hasOwnProperty("Items") && this.boxes[i].product.Items.length > 0) {
            if (this.boxes[i].product.Items[0].Picture !== '') {
              this.boxes[i].product.Items[0].Picture = '';
            }
          }
        }

        params["Q" + i] = QuadrantObject._createRequestObject(this.boxes[i]);
      }
      console.log("params", params)
      let Preferences = {
        FunctionId: "dbAction",
        Action: "REPLACE",
        TableName: "config.UserQuadrants",
        Columns: {
          UserId: this.$store.getters["auth/userName"],
          Quadrants: JSON.stringify(params),
        }
      };

      return Preferences;
    },
    storeConfiguration() {
      // This used to be the generic call saveUserQuadrants
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call saveUserQuadrants was successful",
            response
          );
        },
        error => {
          console.log(
            "The generic call saveUserQuadrants was not successful ",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.accountManagerObjectId,
        this.getCurrentPropertyTable(),
      );
    },
    addQuadrant() {
      // Retrieving the current account id
      console.log("current account", this.currentAccountId);

      this.columns = 3;
      console.log("addQuadrant rows and columns", this.rows, this.columns);
      console.log("addQuadrant", this.newQuad);

      const objId = this.newQuad.object.locationId;

      let profile = JSON.parse(JSON.stringify(this.baseProfile));
      let sigObjMap = new Map().set(objId, []);
      let obj = "OperationalScreen_MapQuadrant";
      //found empty position
      let _x = null;
      let _y = null;
      for (let y = 0; y < this.rows; y++) {
        for (let x = 0; x < this.columns; x++) {
          let isBusy = false;
          for (let i = 0; i < this.boxes.length; i++) {
            let el = this.boxes[i];
            if (el.position.x == x && el.position.y == y) {
              isBusy = true;
            }
          }
          // console.log('check for boxes', this.boxes)
          if (!isBusy) {
            _x = x;
            _y = y;
            y = this.rows;
            break;
          }
        }
      }
      let accountId = this.currentAccountId;
      let objectId = '';
      switch (this.newQuad.type) {
        case "Map":
          obj = "OperationalScreen_MapQuadrant";
          sigObjMap.set(accountId, []);
          sigObjMap
            .get(accountId)
            .push(["incidentAspectUpdate", ["IncidentAspectData"]]);
          sigObjMap.set(objId, []);
          sigObjMap
            .get(objId)
            .push(["locationAspectUpdate", ["LocationAspectData"]]);
          for (const userGroupId of this.userGroupSelections) {
            let ugId = accountId + "_UG_" + userGroupId;
            sigObjMap.set(ugId, []);
            sigObjMap.get(ugId).push(["userAspectUpdate", ["UserAspectData"]]);
          }
          break;

        case "Event":
          obj = "OperationalScreen_EventQuadrant";
          this.$store.commit("setChosenLocationId", objId);
          break;
        case "Incident":
          obj = "OperationalScreen_IncidentQuadrant";
          this.$store.commit("setChosenLocationId", objId);
          //Added listen to incident update signals
          sigObjMap.set(accountId, []);
          sigObjMap
            .get(accountId)
            .push(["incidentAspectUpdate", ["IncidentAspectData"]]);
          break;
        case "ProductCalendar":
          obj = "OperationalScreen_ProductCalendar";
          console.log("Lorenzo this.newQuad.object.EventId", this.newQuad.object.EventId);
          this.$store.commit("setProductIdForCalendar", this.selectedProduct);
          console.log("Lorenzo this.selectedProduct", this.selectedProduct);
          this.$store.commit("setEventIdForCalendar", this.newQuad.object.EventId);
          objectId = this.newQuad.object.EventId;
          break;
        case "EventCalendar":
          obj = "OperationalScreen_EventCalendar";
          console.log("Lorenzo this.newQuad.object.EventId dshfdshfkdsa", this.newQuad.object);
          this.$store.commit("setEventIdForCalendar", this.newQuad.object);
          console.log("Lorenzo this.newQuad.object", this.newQuad.object);
          objectId = this.newQuad.object.EventId;
          this.eventDetails = {
            EventTranslationName: this.newQuad.object.EventTranslationName,
            EventId: this.newQuad.object.EventId,
            ChosenLocation: this.newQuad.object.ChosenLocation,
            OrderType: this.newQuad.object.OrderType,
            Type: this.newQuad.object.Type,
          };
          break;
        case this.QUDRANT_TYPE_WEBSHOP_OVERVIEW: {
          obj = "OperationalScreen_" + this.QUDRANT_TYPE_WEBSHOP_OVERVIEW;
          objectId = this.newQuad.object.EventId;
          this.$store.commit("setEventIdForCalendar", this.newQuad.object);

          // Tmp
          this.eventDetails = {
            EventTranslationName: this.newQuad.object.EventTranslationName,
            EventId: this.newQuad.object.EventId,
            ChosenLocation: this.newQuad.object.ChosenLocation,
            OrderType: this.newQuad.object.OrderType,
            Type: this.newQuad.object.Type,
          };
        }
      }
      console.log("quadrant sigObjMap", sigObjMap);
      let box = {};
      if (this.newQuad.type !== 'EventCalendar' && this.newQuad.type !== 'ProductCalendar' && this.newQuad.type !== this.QUDRANT_TYPE_WEBSHOP_OVERVIEW) {
        box = makeBox(
          {
            type: obj,
            profile: profile,
            signalMap: sigObjMap,
            tag: this.newQuad.object.name,
            location: this.newQuad.object,
            _x: _x,
            _y: _y,
            paramFlag: true,
            componentId: this.componentId,
            columns: this.columns,
            rows: this.rows,
          },
          this.windowHeight,
          this.windowWidth,
        );
      } else {
        box = makeBox(
          {
            type: obj,
            profile: profile,
            signalMap: sigObjMap,
            tag: this.newQuad.object.name,
            location: objectId,
            _x: _x,
            _y: _y,
            paramFlag: true,
            componentId: this.componentId,
            columns: this.columns,
            rows: this.rows,
            product: this.selectedProduct,
            event: this.eventDetails,
          },
          this.windowHeight,
          this.windowWidth
        );
        console.log("Lorenzo box", box);
      }
      console.log("box", box)
      this.boxes.push(box);
      this.dialog = false;

      this.storeConfiguration();

      console.log("add quadrant", this.boxes);
      this.userGroupSelections = [];
    },
    removeQuadrant(id) {
      console.log("removeQuadrant", id);
      this.activeGrid = true;
      this.removeBox(id);
      this.storeConfiguration();
      if (this.boxes.length < 6) {
        this.disableOnEnlarge = false;
      }
    },
    getWindowSize(event) {
      this.windowWidth = document.getElementById("jonny_area").clientWidth;
      this.windowHeight = document.getElementById("jonny_area").clientHeight;
      let copyParam = this.operationalScreenParam;

      let _w = this.windowWidth / this.columns;
      let _h = this.windowHeight / this.rows;
      copyParam.w = _w;
      copyParam.h = _h;
      this.$store.commit("setOperationalScreenSize", copyParam);
      this.buildSettings();
    },
    buildSettings() {
      let _w = this.windowWidth / this.columns;
      let _h = this.windowHeight / this.rows;
      this.settings = {
        origPos: {
          x: 0,
          y: 0
        },
        bubbleUp: false,
        columns: JSON.parse(JSON.stringify(this.columns)),
        rows: JSON.parse(JSON.stringify(this.rows)),
        margin: 5,
        cellSize: {
          w: _w,
          h: _h
        }
      };
      // console.log("buildSettings executed", this.settings);
    }
  }
};
</script>
<style lang="scss" scoped="">
</style>
